import {
  Box,
  Grid,
  Checkbox,
  Button,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Select,
  MenuItem,
  Typography,
  usePagination,
} from "@mui/material";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import cssVariables from "../../theme/cssVariables";
import * as Util from "../../services/global.service";

import fileBrowser from "../../icons/file-browser.svg";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";

import CustomPagination from "../../components/CustomPagination";

// rest service
import { getMemberList } from "../../actions/corporateGoal";

function StylePaper(props) {
  return (
    <Paper component="div" sx={{ padding: "0.5rem 1.5rem 1.5rem 1.5rem", minHeight: "65vh" }}>
      {props.children}
    </Paper>
  );
}

function NoData() {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell colSpan={6} sx={{ borderBottom: "0!important" }}>
        <Box
          textAlign="center"
          sx={{ fontWeight: 300, flexFlow: "column" }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box>
            <img src={fileBrowser} alt="browser" />
          </Box>
          <Box>
            <Typography color="#A0A0A0">{t("label.nodata")}</Typography>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  )
}

const MemberTable = (props) => {
  const _ = require("lodash")
  const { t } = useTranslation()
  const [list, setList] = React.useState([])
  const [masterList, setMasterList] = React.useState([])
  const [filteredList, setFilteredList] = React.useState([])
  const [perPage, setPerPage] = React.useState(10)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalPage, setTotalPage] = React.useState(1)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("");
  const [checkboxStatus, setCheckboxStatus] = React.useState("")
  const language = localStorage.getItem("lang")

  // styles
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "400",
      // color: "#A0A0A0"
    },
    iconContainer: {
      width: 40,
      height: 40,
      borderRadius: 5,
      marginTop: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    profileContainer: {
      width: 40,
      height: 40,
      borderRadius: "50%",
      marginTop: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    statusBadge: {
      width: "fit-content",
      minWidth: "120px",
      borderRadius: "5px",
      padding: "10px",
    },
    draftBg: {
      background: "#EFB76D26"
    },
    draftText: {
      color: "#EFB76D"
    },
    pendingBg: {
      background: "#F280261A"
    },
    pendingText: {
      color: "#F28026"
    },
    approveBg: {
      background: "#5DA19626"
    },
    approveText: {
      color: "#5DA196"
    },
    rejectedBg: {
      background: "#CC605826"
    },
    rejectedText: {
      color: "#CC6058"
    },
    cancelBg: {
      background: "#82828226",
    },
    cancelText: {
      color: "#828282",
    },
    cancelPendingBg: {
      background: "#82828226"
    },
    cancelPendingText: {
      color: "#828282",
    },
    completedBg: {
      background: "rgba(93, 161, 150, 0.15);",
    },
    completedText: {
      color: "#5DA196",
    },
    blueBg: {
      background: "#6694CC",
    },
    purpleBg: {
      background: "#7580BD",
    },
    btnContainer: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      flexGrow: 1,
    },
    btnActive: {
      background: cssVariables.color.primary,
      color: `${cssVariables.color.white}!important`,
      "&:hover": {
        backgroundColor: "#4f8a80",
      },
    },
    btnInactive: {
      "&:hover": {
        backgroundColor: "#5da19626",
      },
    },
    btn: {
      transition: "0.2s",
      cursor: "pointer",
      borderRadius: "5px",
      padding: "10px",
      color: cssVariables.color.black,
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    tableHover: {
      transition: "0.5s",
      "&:hover": {
        background: "#4043490f",
        cursor: "pointer",
      },
    },
    unactiveSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    },
    activeSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    },
  })

  const classes = useStyles()

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
  }
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
  }
  const handleTotalPage = () => {
    const List = filteredList.length > 0 ? JSON.parse(JSON.stringify(filteredList)) : []
    const totalPage =
      List.length > 0 ? Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage) : 1
    setTotalPage(totalPage);
  }

  const handleRequestSort = (property, direction = "") => {
    if (direction === "") {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
    } else {
      if (direction === "asc" || direction === "desc") {
        setOrder(direction);
      }
    }
    setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    })
    return stabilizedThis.map((el) => el[0]);
  }


  const [checkbox, setCheckbox] = React.useState([]);
  const handleCheckbox = (check) => {
    let tmpCheckbox = [...checkbox]
    if (check !== "all") {
      if (tmpCheckbox.includes(check)) {
        tmpCheckbox = tmpCheckbox.filter(item => item !== check)
      } else {
        tmpCheckbox.push(check)
      }
      setCheckbox(tmpCheckbox);
    } else {
      if (checkboxStatus === "some" || checkboxStatus === "") {
        let selectAllCheckbox = filteredList.map(item => item.formEvaluateID)
        setCheckbox(selectAllCheckbox)
      } else {
        setCheckbox([])
      }
    }
  }


  // useEffect
  // first page load & set state
  useEffect(() => {
    if (props.cycleSerial && props.cycleSerial != "") {
      let options = {}
      if (props?.goal) options.goal = props.goal

      dispatch(getMemberList(props.cycleSerial, options)).then(resp => {
        if (resp.success) {
          if (resp?.data?.goalMemberList) {
            let memberList = resp.data.goalMemberList.filter(item => { return item.formStatus === 'draft' })

            setList(memberList ?? [])
          }
        }
      })
    }
  }, [props.cycleSerial])

  useEffect(() => {
    let tmpList = JSON.parse(JSON.stringify(list))
    if (props.preSelected?.currentMembers && props.preSelected?.currentMembers?.length > 0) {
      tmpList = tmpList.filter(item => {
        return props.preSelected.currentMembers.findIndex(cur => cur.form_evaluate_id === item.formEvaluateID) === -1
      })
    }
    setFilteredList(tmpList)
    setMasterList(tmpList)
  }, [props.preSelected, list])
  // update list when search changed

  useEffect(() => {
    let result = [];
    if (props.search !== "") {
      result = masterList.filter((item) => {
        return Object.keys(item).some((key) => {
          if (item[key]) {
            return item[key].toString().toLowerCase().indexOf(props.search.toLowerCase()) !== -1;
          }
          return item[key];
        })
      })
    } else {
      result = masterList
    }
    setFilteredList(result)
  }, [props.search, masterList])

  useEffect(() => {
    props.returnSelectedList(checkbox)
    props.returnTotalSelectedNumber(checkbox.length)
  }, [checkbox])

  useEffect(() => {
    props.returnList(list)
  }, [list])

  useEffect(() => {
    if (filteredList.every((list) => checkbox.includes(list.formEvaluateID))) {
      setCheckboxStatus("all")
    } else if (filteredList.some((list) => checkbox.includes(list.formEvaluateID))) {
      setCheckboxStatus("some")
    } else {
      setCheckboxStatus("")
    }
  }, [checkbox, filteredList])
  // end useEffect

  // data for show
  const currentTableData = useMemo(() => {
    handleTotalPage();
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    const result = filteredList.slice(firstPageIndex, lastPageIndex)
    return result
  }, [filteredList, currentPage, perPage])

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <Grid container mt={2}>
          <Grid item xs sm md lg>
            <TableContainer component={StylePaper}>
              <Table sx={{ width: "100%" }} aria-label="simple table">
                <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                  <TableRow>
                    <TableCell align="left">
                      <Checkbox
                        checked={checkboxStatus === "all"}
                        indeterminate={checkboxStatus === "some"}
                        onChange={() => handleCheckbox("all")}
                      />
                    </TableCell>
                    <TableCell align="left" sortDirection="asc" display="flex" >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        color="#A0A0A0"
                        sx={{ display: "flex" }}
                        component={'span'}
                      >
                        {t("corporateGoal.label.memberTable.code")}
                        <Box sx={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("code", "asc")} className={orderBy === "code" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("code", "desc")} className={orderBy === "code" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>
                    <TableCell align="left" sortDirection="asc" display="flex" >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        color="#A0A0A0"
                        sx={{ display: "flex" }}
                        component={'span'}
                      >
                        {t("corporateGoal.label.memberTable.name")}
                        <Box sx={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("fullNameEN", "asc")} className={orderBy === "fullNameEN" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("fullNameEN", "desc")} className={orderBy === "fullNameEN" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        color="#A0A0A0"
                        sx={{ display: "flex" }}
                        component={'span'}
                      >
                        {t("corporateGoal.label.memberTable.position")}
                        <Box sx={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empSubName", "asc")} className={orderBy === "empSubName" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empSubName", "desc")} className={orderBy === "empSubName" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        color="#A0A0A0"
                        sx={{ display: "flex" }}
                        component={'span'}
                      >
                        {t("corporateGoal.label.memberTable.positionType")}
                        <Box sx={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empPositionType", "asc")} className={orderBy === "empPositionType" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empPositionType", "desc")} className={orderBy === "empPositionType" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="left"
                      className="clickable"
                    >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0", display: "flex" }}
                        component={'span'}
                      >
                        {t("corporateGoal.label.memberTable.team")}
                        <Box style={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empName", "asc")} className={orderBy === "empName" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empName", "desc")} className={orderBy === "empName" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="left"
                      className="clickable"
                    >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0", display: "flex" }}
                        component={'span'}
                      >
                        {t("admin.inputForm.goalTemplate")}
                        <Box style={{ flexDirection: "column", justifyContent: "center", display: "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("template", "asc")} className={orderBy === "template" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("template", "desc")} className={orderBy === "template" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentTableData.length > 0 ? (
                    stableSort(currentTableData, getComparator(order, orderBy)).map((row) =>
                    (
                      <TableRow
                        key={row.formEvaluateID}
                        classes={{ root: classes.tableHover }}
                        onClick={() => handleCheckbox(row.formEvaluateID)}
                      >
                        <TableCell align="left">
                          <Checkbox onChange={() => handleCheckbox(row.formEvaluateID)} checked={checkbox.includes(row.formEvaluateID)} />
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontSize={16} sx={{ color: "#404349" }} fontWeight="400">
                            {row.code}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Box display="flex">
                            <Box
                              display="flex"
                              alignItems="flex-start"
                              justifyContent="start"
                              sx={{ flexFlow: "column" }}
                            >
                              <Typography
                                variant="h4"
                                fontWeight="500"
                                fontSize={18}
                                color="#404349"
                              >
                                {row.fullNameEN}
                              </Typography>
                              <Typography
                                variant="h5"
                                fontSize={16}
                                color="#404349"
                                fontWeight="400"
                              >
                                {row.fullNameTH}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontSize={16} color="#404349" fontWeight={400}>
                            {row.empSubName}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontSize={16} color="#404349" fontWeight={400}>
                            {row.empPositionType}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontSize={16} color="#404349" fontWeight={400}>
                            {row.empName}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontSize={16} color="#404349" fontWeight={400}>
                            {row.template}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )
                    )
                  ) : (
                    <NoData />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs sm md display="flex" alignItems="center">
              <Box mr={1}>
                <Typography variant="s14_fw400">{t("label.showMaxItems")}</Typography>
              </Box>
              <Select
                id="pagination"
                variant="outlined"
                defaultValue={10}
                value={perPage}
                onChange={handlePerPageChange}
                displayEmpty
                size="small"
                className="white-bg"
              >
                <MenuItem value={10}>
                  <Typography style={{ fontWeight: "300" }}>10</Typography>
                </MenuItem>
                <MenuItem value={20}>
                  <Typography style={{ fontWeight: "300" }}>20</Typography>
                </MenuItem>
                <MenuItem value={50}>
                  <Typography style={{ fontWeight: "300" }}>50</Typography>
                </MenuItem>
                <MenuItem value={100}>
                  <Typography style={{ fontWeight: "300" }}>100</Typography>
                </MenuItem>
              </Select>
            </Grid>
            <Grid item display="flex" alignItems="center" ml="auto">
              <Typography variant="s14_fw400">
                {t("label.page")} {currentPage} {t("label.of")} {totalPage}
              </Typography>
            </Grid>
            <Grid item ml="auto" display="flex" alignItems="center">
              <CustomPagination
                setCurrentPage={handleSetCurrentPage}
                selected={currentPage}
                count={totalPage}
              ></CustomPagination>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default MemberTable;
